import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchLeagueView } from '../../api/api';
import LeagueOverallRanking from './LeagueOverallRanking';
import LeagueAwards from './LeagueAwards';
import Spinner from '../Spinner/Spinner';
import styles from './LeagueRankingPage.module.css';

const LeagueRankingPage = () => {
    const { tournamentId } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            const result = await fetchLeagueView(tournamentId);
            if (result.success) {
                setData(result.data);
            }
            setIsLoading(false);
        };
        loadData();
    }, [tournamentId]);

    if (isLoading || !data) return <Spinner />;

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate('/tournaments', { state: { activeTab: 'current', tournamentId: parseInt(tournamentId) } })}>
                &#8592; Powrót
            </button>
            <div className={styles.header}>
                <p className={styles.tournamentName}>{data.tournament?.name}</p>
            </div>
            <LeagueOverallRanking rankings={data.overallRanking} />
            <LeagueAwards awards={data.leagueAwards} />
        </div>
    );
};

export default LeagueRankingPage;
